import { createSlice } from '@reduxjs/toolkit';

type SnakeBarState = {
    numberOfRequests: number;
};

const initialState: SnakeBarState = {
    numberOfRequests: 0,
};

const snakeBarSlice = createSlice({
    name: 'root/snake-bar',
    initialState,
    reducers: {
        increase: (state) => {
            state.numberOfRequests = state.numberOfRequests + 1;
        },
        decrease: (state) => {
            state.numberOfRequests = state.numberOfRequests - 1;
        },
        reset: (state) => {
            state.numberOfRequests = 0;
        },
    },
});

export default snakeBarSlice.reducer;
